module.exports = __webpack_public_path__ + "static/infrared_homepage_loop_poster-64e9d92b4750b83ebb6fd77d83ec3a4a.jpeg";